/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IAbsoluteCheckoutTermsData } from './absolute-checkout-terms.data';
import { IAbsoluteCheckoutTermsProps } from './absolute-checkout-terms.props.autogenerated';

export interface IAbsoluteCheckoutTermsViewProps extends IAbsoluteCheckoutTermsProps<IAbsoluteCheckoutTermsData> {

    termsTitle?: React.ReactNode;
    termsContent?: string;



}

/**
 *
 * AbsoluteCheckoutTerms component
 * @extends {React.PureComponent<IAbsoluteCheckoutTermsProps<IAbsoluteCheckoutTermsData>>}
 */
class AbsoluteCheckoutTerms extends React.PureComponent<IAbsoluteCheckoutTermsProps<IAbsoluteCheckoutTermsData>> {
    public render(): JSX.Element | null {

        const { 
            termsTitle,
            termsContent
            
            
        } = this.props.config;

        const TermsTitle = termsTitle && (
            <Msdyn365.Text
              tag={termsTitle.tag || 'h2'}
              text={termsTitle.text}
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );

        const TermsContent = termsContent && (
            <Msdyn365.RichTextComponent
                text={`<p className='nick-test'>${termsContent}</p>`}
                editProps={{ onEdit: this.handleParagraphChange1, requestContext: this.props.context.request }}
            />
        );

        const AbsoluteCheckoutTermsProps = {
            ...this.props,
            termsTitle: TermsTitle,
            termsContent: TermsContent,
        }




        return this.props.renderView(AbsoluteCheckoutTermsProps) as React.ReactElement;
    }

    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.termsTitle!.text = event.target.value;
    public handleParagraphChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.termsContent! = event.target.value;


}

export default AbsoluteCheckoutTerms;
